import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { round } from 'lodash';
import label from '../../utils/lngEn';
import FormField from '../common/FormField';
import Validate from '../common/formValidate';
import { Row, Col } from 'react-bootstrap';
import DropdownList from 'react-widgets/lib/DropdownList';

const renderDropdownList = ({ input, meta: { touched, error }, ...rest }) => (
  <div>
    <DropdownList {...input} {...rest} />
    <div>{touched && (error && <span className="text-danger">{error}</span>)}</div>
  </div>
);

const validate = values => {
  const errors = {};

  if (values.target_course_units && parseFloat(values.target_course_units) < 0) {
    errors.target_course_units = 'Must not be a negative number';
  } else if (
    parseFloat(values.max_course_units) &&
    round(parseFloat(values.target_course_units), 1) > round(parseFloat(values.max_course_units), 1)
  ) {
    errors.max_course_units = 'Target course units must be not be smaller than minimum course units';
  }
  return errors;
};

const number = value => (value ? value : null);
const StudentForm = props => {
  const { handleSubmit, submitting, initialValues, adjustedBudget, assignment_complete } = props;
  return (
    <form onSubmit={handleSubmit} className="student-form mt-4">
      {!initialValues.id ? (
        <Field
          name="email"
          type="email"
          component={FormField}
          label={label.emailAddress}
          validate={[Validate.Required]}
          description={label.studentEmailDesc}
        />
      ) : null}

      <Field
        name="identifier"
        type="text"
        component={FormField}
        label={label.studentIdentifier}
        validate={[]}
        description={label.studentIdentifierDesc}
      />
      {!assignment_complete && (
        <Row>
          <Col md={6}>
            <div className="form-group">
              <Field
                name="base_budget"
                valueField="value"
                textField="option"
                data={[
                  { option: '100 - Typical student', value: 100 },
                  { option: '110 - Small boost', value: 110 },
                  { option: '150 - Large boost', value: 150 },
                  { option: '350 - Huge boost', value: 350 }
                ]}
                component={renderDropdownList}
              />
              <span className="input-description">{label.baseBudget}</span>
            </div>
          </Col>
          <Col md={6}>
            {adjustedBudget > 0 ? (
              <div className="form-group mb-2 adjusted-budget">
                <div className="form-control">{adjustedBudget / 100}</div>
                <span className="input-description">{label.adjustedBudget}</span>
              </div>
            ) : null}
          </Col>
        </Row>
      )}
      <Row>
        <Col md={6}>
          <Field
            name="target_course_units"
            type="number"
            component={FormField}
            normalize={number}
            label={label.targetCourseUnits}
            description={label.targetCourseUnits}
          />
        </Col>
        <Col md={6}>
          <Field
            name="max_course_units"
            type="number"
            component={FormField}
            normalize={number}
            label={label.maxCourseUnits}
            description={label.maxCourseUnits}
          />
        </Col>
      </Row>

      <button className="btn btn-primary pull-right" type="submit" disabled={submitting}>
        Save
      </button>
    </form>
  );
};

export default reduxForm({
  form: 'StudentForm',
  validate
})(StudentForm);



// WEBPACK FOOTER //
// ./src/components/students/StudentForm.js